import { useQuery } from '@apollo/client';
import { BakerUserList } from '@bakerweb/models';
import { GET_BAKER_USERS } from '../graphql/queries/getBakerUsers';

export const useGetBakerUsers = () => {
  const { loading, error, data, refetch } = useQuery<{ bakerUsers: BakerUserList[] }>(GET_BAKER_USERS, {
    fetchPolicy: 'cache-and-network'
  });

  const users = data?.bakerUsers ?? [];

  return { loading, error, users, refetch };
};
